import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bd08f0a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-area" }
const _hoisted_2 = { class: "buttons" }
const _hoisted_3 = { class: "social-area" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "animate context-menu" }
const _hoisted_7 = { class: "friend-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "profile"
}
const _hoisted_11 = {
  key: 2,
  style: {"font-size":"12px"}
}
const _hoisted_12 = {
  key: 3,
  style: {"font-size":"12px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "title"
}
const _hoisted_15 = {
  key: 1,
  class: "animate context-menu"
}
const _hoisted_16 = { class: "search-form" }
const _hoisted_17 = { class: "friend-list" }
const _hoisted_18 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_19 = {
  key: 1,
  style: {"font-size":"12px"}
}
const _hoisted_20 = {
  key: 2,
  class: "title"
}
const _hoisted_21 = {
  key: 3,
  class: "animate context-menu"
}
const _hoisted_22 = { class: "search-form" }
const _hoisted_23 = { class: "friend-list" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_26 = {
  key: 1,
  style: {"font-size":"12px"}
}
const _hoisted_27 = {
  key: 0,
  class: "main codebite-container"
}
const _hoisted_28 = {
  key: 1,
  class: "main codepost-container"
}
const _hoisted_29 = { class: "right" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Mensajería Rápida", -1))
const _hoisted_31 = { class: "animate context-menu" }
const _hoisted_32 = { class: "search-form" }
const _hoisted_33 = { class: "friend-list" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "profile"
}
const _hoisted_37 = { style: {"font-size":"12px"} }
const _hoisted_38 = { style: {"position":"absolute"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Últimas Preguntas", -1))
const _hoisted_41 = { class: "animate context-menu" }
const _hoisted_42 = { class: "search-form" }
const _hoisted_43 = { class: "friend-list" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_46 = {
  key: 1,
  style: {"font-size":"12px"}
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_49 = {
  key: 1,
  style: {"font-size":"12px"}
}

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ChannelHeader from '@/components/channel/ChannelHeader.vue';
import ProfileService from '@/services/ProfileService';
import FriendshipService from '@/services/FriendshipService';
import { ref, onMounted, onUnmounted,Ref } from 'vue'
import { useAuth } from '@/store/useAuth';
import { Toast } from '@/interfaces/ToastInterface'
import { useToast } from '@/store/useToast'
import { useConversations } from '@/store/useConversations'
import router from '@/router'
import ChannelService from '@/services/ChannelService';
import ForumService from '@/services/ForumService';
import CodeBite from '@/components/cards/CodeBite.vue';
import CodePost from '@/components/cards/CodePost.vue';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyWallView',
  setup(__props) {

const codebites = ref()
const codeposts = ref()
const service = new ProfileService()
const store = useAuth()
const user = ref()
const friends:Ref<any> = ref([])
const filteredFriends:Ref<any> = ref([])
const friendshipService = new FriendshipService()
const search = ref('')
const toast = useToast()
const storeConversations = useConversations()
const showCodeBites = ref(false)
const mostReputated = ref()
const codebitesSaved = ref()
const filteredCodeBitesSaved = ref()
const codepostsSaved = ref()
const searchCodeBitesSaved = ref('')
const searchCodePostsSaved = ref('')
const searchQuestion = ref('')
const filteredCodePostsSaved = ref()
const channelService = new ChannelService()
const forumService = new ForumService()
const questions = ref()
const filteredQuestions = ref()
const intervalId = window.setInterval(async () => {
    if (!store.token) {
        return
    }
    friends.value = await friendshipService.listUserFriends(store.token)
    filteredFriends.value = friends.value
}, 10000)

onMounted(async () => {
    if (!store.token) { return }
    user.value = await service.MyUser(store.token)
    friends.value = await friendshipService.listUserFriends(store.token)
    filteredFriends.value = friends.value
    mostReputated.value = await channelService.GetMostReputatedChannels()
    codebitesSaved.value = await channelService.GetSavedCodeBites(store.token)
    filteredCodeBitesSaved.value = codebitesSaved.value
    codepostsSaved.value = await channelService.GetSavedCodePosts(store.token)
    filteredCodePostsSaved.value = codepostsSaved.value
    questions.value = await forumService.LatestQuestions()
    filteredQuestions.value = questions.value
    codebites.value = await channelService.CodeBiteFeeder(store.token)
    codeposts.value = await channelService.CodePostFeeder(store.token)
})

onUnmounted(() => {
    clearInterval(intervalId);
})

const showConversation = async (id: number) => {
    if (!store.token) {
        return
    }
    const success = await storeConversations.addConversation(store.token, id)
    if (!success) {
        toast.showToast("No puedes abrir más pop-ups de conversación simultáneos. Visita la sección de mensajería para acceder a todas las capacidades.", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000);
    }
}

const handleSearchQuestions = () => {
    filteredQuestions.value = questions.value.filter((item:any)=> item.name.toLowerCase().includes(searchQuestion.value.toLowerCase()))
}

const handleSearchCodeBitesSaved = () => {
    filteredCodeBitesSaved.value = codebitesSaved.value.filter((item:any) => item.codebite.title.toLowerCase().includes(searchCodeBitesSaved.value.toLowerCase()))
}

const handleSearchCodePostsSaved = () => {
    filteredCodePostsSaved.value = codepostsSaved.value.filter((item:any) => item.codepost.title.toLowerCase().includes(searchCodePostsSaved.value.toLowerCase()))
}

const handleSearch = () => {
    filteredFriends.value = friends.value.filter((item:any)=> item.name.toLowerCase().includes(search.value.toLowerCase()))
}
const handleShowCodeBites = async () => {
    if(!store.token) { return }
    showCodeBites.value = true
    codebites.value = await channelService.CodeBiteFeeder(store.token)
   
}
const handleShowCodePosts = async () => {
    if(!store.token) { return }
    showCodeBites.value = false
    codeposts.value = await channelService.CodePostFeeder(store.token)
}

const refresh = async () => {
    if(!store.token) { return }
    codebites.value = await channelService.CodeBiteFeeder(store.token)
    codeposts.value = await channelService.CodePostFeeder(store.token)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ConversationNotification = _resolveComponent("ConversationNotification")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(ChannelHeader, { user: user.value }, null, 8, ["user"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "new-question",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name: 'social-profile-edit'})))
          }, [
            _createVNode(_component_v_icon, {
              name: "bi-pencil-fill",
              style: {"margin-right":"5px"}
            }),
            _createTextVNode("Editar Cabecera")
          ]),
          _createElementVNode("button", {
            class: "new-question",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({name: 'search-channels'})))
          }, [
            _createVNode(_component_v_icon, {
              name: "ri-user-follow-fill",
              style: {"margin-right":"5px"}
            }),
            _createTextVNode("A Quién Seguir")
          ]),
          _createElementVNode("button", {
            class: _normalizeClass({'new-question': true, 'marked': showCodeBites.value}),
            onClick: handleShowCodeBites
          }, [
            _createVNode(_component_v_icon, {
              name: "bi-file-code-fill",
              style: {"margin-right":"5px"}
            }),
            _createTextVNode("Ver Shorts")
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass({'new-question': true, 'marked': !showCodeBites.value}),
            onClick: handleShowCodePosts
          }, [
            _createVNode(_component_v_icon, {
              name: "bi-file-post",
              style: {"margin-right":"5px"}
            }),
            _createTextVNode("Ver Posts")
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref(main).TITLE_HALL_OF_FAME), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mostReputated.value, (friend, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: friend.id
                  }, [
                    _createElementVNode("div", {
                      class: "friend",
                      onClick: ($event: any) => (_unref(router).push({name:'social-profile', params: {id: friend.id}})),
                      target: "_blank"
                    }, [
                      (friend.profile_picture_uri)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "profile",
                            src: friend.profile_picture_uri,
                            width: "28"
                          }, null, 8, _hoisted_9))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(friend.name.substring(0, 2)), 1)),
                      (friend.name.length < 22)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_11, _toDisplayString(index+1) + ". " + _toDisplayString(friend.name), 1))
                        : (_openBlock(), _createElementBlock("h5", _hoisted_12, _toDisplayString(index+1) + ". " + _toDisplayString(friend.name.substring(0,22)) + "...", 1))
                    ], 8, _hoisted_8)
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_13,
            (showCodeBites.value)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_14, "Shorts Guardados"))
              : _createCommentVNode("", true),
            (showCodeBites.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("form", _hoisted_16, [
                    _createVNode(_component_v_icon, { name: "fa-filter" }),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Buscar Short...",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchCodeBitesSaved).value = $event)),
                      onKeyup: handleSearchCodeBitesSaved
                    }, null, 544), [
                      [_vModelText, searchCodeBitesSaved.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCodeBitesSaved.value, (friend) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: friend.id
                      }, [
                        _createElementVNode("div", {
                          class: "friend",
                          style: {"justify-content":"flex-end"},
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push({name: 'codebites-saved'})))
                        }, [
                          (friend.codebite.title.length < 28)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_18, _toDisplayString(friend.codebite.title), 1))
                            : (_openBlock(), _createElementBlock("h5", _hoisted_19, _toDisplayString(friend.codebite.title.substring(0,28)) + "...", 1))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!showCodeBites.value)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_20, "Posts Guardados"))
              : _createCommentVNode("", true),
            (!showCodeBites.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("form", _hoisted_22, [
                    _createVNode(_component_v_icon, { name: "fa-filter" }),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Buscar Post...",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchCodePostsSaved).value = $event)),
                      onKeyup: handleSearchCodePostsSaved
                    }, null, 544), [
                      [_vModelText, searchCodePostsSaved.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCodePostsSaved.value, (friend) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: friend.id
                      }, [
                        _createElementVNode("div", {
                          class: "friend",
                          style: {"justify-content":"flex-end"},
                          onClick: ($event: any) => (_unref(router).push({name: 'codepost-view', params: {id: friend.codepost.id}}))
                        }, [
                          (friend.codepost.title.length < 35)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_25, _toDisplayString(friend.codepost.title), 1))
                            : (_openBlock(), _createElementBlock("h5", _hoisted_26, _toDisplayString(friend.codepost.title.substring(0,35)) + "...", 1))
                        ], 8, _hoisted_24)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (showCodeBites.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codebites.value, (codebite) => {
                  return (_openBlock(), _createBlock(CodeBite, {
                    key: codebite.id,
                    codebite: codebite,
                    user: codebite.user,
                    onRefresh: refresh
                  }, null, 8, ["codebite", "user"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeposts.value, (codepost) => {
                  return (_openBlock(), _createBlock(CodePost, {
                    key: codepost.id,
                    codepost: codepost,
                    user: codepost.user,
                    onRefresh: refresh
                  }, null, 8, ["codepost", "user"]))
                }), 128))
              ])),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_RouterLink, {
                to: { name: 'messages' },
                style: {"text-decoration":"none","font-size":"12px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ir a mensajería.")
                ]),
                _: 1
              }),
              _createVNode(_component_RouterLink, {
                to: { name: 'friends' },
                style: {"text-decoration":"none","font-size":"12px","margin-left":"5px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Añadir amigos.")
                ]),
                _: 1
              }),
              _createElementVNode("form", _hoisted_32, [
                _createVNode(_component_v_icon, { name: "fa-filter" }),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Buscar amigo...",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((search).value = $event)),
                  onKeyup: handleSearch
                }, null, 544), [
                  [_vModelText, search.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFriends.value, (friend) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: friend.id
                  }, [
                    _createElementVNode("div", {
                      class: "friend",
                      onClick: ($event: any) => (showConversation(friend.id))
                    }, [
                      (friend.profile_picture_uri)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "profile",
                            src: friend.profile_picture_uri,
                            width: "28"
                          }, null, 8, _hoisted_35))
                        : (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(friend.name.substring(0, 2)), 1)),
                      _createElementVNode("h5", _hoisted_37, _toDisplayString(friend.name), 1),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_ConversationNotification, {
                          friendId: friend.id,
                          style: {"position":"relative","top":"0"}
                        }, null, 8, ["friendId"])
                      ])
                    ], 8, _hoisted_34)
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_39,
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("form", _hoisted_42, [
                _createVNode(_component_v_icon, { name: "fa-filter" }),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Buscar pregunta...",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchQuestion).value = $event)),
                  onKeyup: handleSearchQuestions
                }, null, 544), [
                  [_vModelText, searchQuestion.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredQuestions.value, (friend) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: friend.id
                  }, [
                    (friend.lesson)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "friend",
                          style: {"justify-content":"right"},
                          onClick: ($event: any) => (_unref(router).push({ name: 'detail-question-lessons-course', params: { course_id: friend.lesson.course.id, lesson_id: friend.lesson.id, question_id: friend.id } }))
                        }, [
                          (friend.name.length < 35)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_45, _toDisplayString(friend.name), 1))
                            : (_openBlock(), _createElementBlock("h5", _hoisted_46, _toDisplayString(friend.name.substring(0,35)) + "...", 1))
                        ], 8, _hoisted_44))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "friend",
                          style: {"justify-content":"right"},
                          onClick: ($event: any) => (_unref(router).push({ name: 'detail-question-general', params: { topic_id: friend.topic.id, question_id: friend.id, topic_name: friend.topic.name } }))
                        }, [
                          (friend.name.length < 35)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_48, _toDisplayString(friend.name), 1))
                            : (_openBlock(), _createElementBlock("h5", _hoisted_49, _toDisplayString(friend.name.substring(0,35)) + "...", 1))
                        ], 8, _hoisted_47))
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})